<template>
    <FormDialog :title="title" :isShow.sync="isShow" width="480px" v-on:resetForm="close()">
    <div class="addplot-contrast-list">
         <div class="globalSearchbar">
        <el-input clearable
                  @input="inputHandler"
                  @clear="searchClear"
                   @focus="focusHandler"
                   :placeholder="selectedQueryTextTips" v-model="keyWord" class="input-with-select" @keyup.enter.native="searchEnterFun">
            <el-select  @change="querySelectChange($event)" v-model="selectedQueryValue" slot="prepend" placeholder="请选择">
                <el-option v-for="(item, index) in queryItems" :key="'queryItems'+index" :value="item.value" :label="item.label"></el-option>
            </el-select>
               <el-button slot="append" icon="iconfont icon-sousuo" @click="searchExcuteFun" ></el-button>
              <!--  <el-button slot="append" type="info" icon="iconfont icon-guanbi" @click="searchClear" v-if="resultListViewShow"></el-button> -->
        </el-input>
       </div>
        <div class="plot" v-show="!addplotListExpand" style="padding: 20px 0px;width: 100%;position: relative;top:40px;">
           <List  :isIndex="true" :isSelection="true" :columns="tableCols" :data="addplotList" stripe ref="list"  v-on:handleSelect="handleSelect"/>
           <div style="position: absolute;top: 435px;left: 180px;">
           <el-button type="primary" @click="addContrast()" size="small">确定</el-button>
           <el-button @click="isShow=false" size="small">取消</el-button>
           </div>
        </div>
    </div>
    </FormDialog>
</template>
<script>
import bus from '@/components/common/bus'
import { Notification } from 'element-ui'
import {mapResourceApi} from '@/api/mapResourceApi'
import {LAND_TYPE} from '@/views/class/mapmanager'
import List from '@/components/list/default'
import FormDialog from '@/components/dialog/formDialog'
import util from '@/js/util'
export default {
  name: 'addplotContrastList',
  components: {
    List,
    FormDialog
  },
  data() {
    return {
      tableCols: [
        { label: '地块名称', prop: 'dkmc' }
      ],
      addplotListExpand: false,
      entranceIcon: '',
      plotList: [],
      addplotList: [],
      list: {},
      keyWord: '',
      isShowTitle: false,
      features: [],
      totalCount: 0,
      selectedQueryTextTips: '请输入查询的内容',
      selectedQueryValue: 0,
      keywordFromMap: false,
      resultListViewShow: false,
      queryItems: [{
        value: LAND_TYPE.land_type_suoyou,
        label: '全部'
      }, {
        value: LAND_TYPE.land_type_gongye,
        label: '工业'
      }, {
        label: '商业',
        value: LAND_TYPE.land_type_shangye
      }, {
        label: '住宅',
        value: LAND_TYPE.land_type_zhuzhai
      }, {
        label: '其他',
        value: LAND_TYPE.land_type_qita
      }],
      title: '添加对比地块',
      isShow: false
    }
  },
  mounted() {
    // todo
    bus.$on('mapSelectedQueryValue', msg => {
      // this.selectedQueryValue = msg
    })
    bus.$on('mapClick', msg => {
      this.keywordFromMap = true
    })
    bus.$on('searchClear', msg => {
      this.keyWord = ''
      this.isShowTitle = false
      this.features = []
      this.addplotList = []
    })
  },
  methods: {
    addContrast() {
      const row = this.rowsData
      if (this.rowsData.length > 4) {
        util.info('地块对比最多只能添加4个地块！')
        return
      }
      for (let i = 0; i < row.length; i++) {
        this.$parent.$refs.refplotContrastList.addContrast(row[i])
      }
    },
    entranceMouseover(data) {
      this.entranceIcon = data
    },
    entranceMouseleave() {
      this.entranceIcon = ''
    },
    // 扩大缩小
    contraction() {
      this.addplotListExpand = !this.addplotListExpand
    },
    // 关闭
    close() {
      this.$parent.addplotContrastListShow = false
    },
    remove(item) {
      const _this = this
      this.plotList.forEach((element, index, arr) => {
        if (item.id === element.id) {
          _this.plotList.splice(index, 1)
        }
      })
    },
    handleSelect (row) {
      this.rowsData = row
    },
    open() {
      this.isShow = true
      this.getQueryWhereParam('')
    },
    /**
       * 查询框的下拉选事件
       */
    querySelectChange(val) {
      debugger
      this.selectedQueryValue = val
      this.isShowTitle = true
      // if (this.resultListViewShow) {
      const keyWord = this.keyWord
      const newArr = []
      if (val !== LAND_TYPE.land_type_suoyou) {
        for (let i = 0; i < this.features.length; i++) {
          if (Number(this.features[i].properties.ydxz) === val && this.features[i].properties.dkmc.indexOf(keyWord) > -1) {
            newArr.push(this.features[i].properties)
          }
        }
      } else {
        for (let i = 0; i < this.features.length; i++) {
          if (this.features[i].properties.dkmc.indexOf(keyWord) > -1) {
            newArr.push(this.features[i].properties)
          }
        }
      }
      if (newArr.length === 0) {
        this.isShowTitle = false
        this.totalCount = 0
      } else {
        this.totalCount = newArr.length
      }
      this.addplotList = newArr
      // }
    },
    querySelectLand(keyWord) {
      const status = '2'
      const params = {
        status
      }
      mapResourceApi.getLandInfoList(params).then(response => {
        debugger
        console.log(response)
        if (response.code === '200') {
          const featuresObj = JSON.parse(response.data)
          // bus.$emit('initListData', featuresObj.features)
          this.features = featuresObj.features
          this.addplotList = []
          this.isShowTitle = false
          for (let i = 0; i < featuresObj.features.length; i++) {
            if (this.selectedQueryValue === 0) {
              if (featuresObj.features[i].properties.dkmc.indexOf(keyWord) > -1) {
                this.isShowTitle = true
                this.addplotList.push(featuresObj.features[i].properties)
              }
            } else {
              if (featuresObj.features[i].properties.dkmc.indexOf(keyWord) > -1 && Number(featuresObj.features[i].properties.ydxz) === this.selectedQueryValue) {
                this.isShowTitle = true
                this.addplotList.push(featuresObj.features[i].properties)
              }
            }
          }
          if (this.addplotList.length === 0) {
            this.isShowTitle = false
            this.totalCount = 0
          } else {
            this.totalCount = this.addplotList.length
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '加载图层数据出错!',
            type: 'warning'
          })
        }
      })
    },
    searchEnterFun(e) {
      const keyCode = window.event ? e.keyCode : e.which
      if (keyCode === 13) {
        const keyWord = this.keyWord
        /* if (keyWord === '') {
          this.$message.warning('请输入搜索条件！')
          return
        } */
        this.getQueryWhereParam(keyWord)
      }
    },
    searchExcuteFun(e) {
      const keyWord = this.keyWord
      /*  if (keyWord === '') {
        this.$message.warning('请输入搜索条件！')
        return
      } */
      this.resultListViewShow = true
      this.getQueryWhereParam(keyWord)
    },
    getQueryWhereParam(queryWord) {
      /*  if (this.keywordFromMap) {
        return
      } */
      this.querySelectLand(queryWord)
    },
    searchClear() {
      console.log('清空')
      this.keyWord = ''
      this.keywordFromMap = false
      this.resultListViewShow = false
      bus.$emit('searchClear')
    },
    focusHandler() {
      const keyWord = this.keyWord
      // this.getQueryWhereParam(keyWord)
    },
    inputHandler(value) {
      if (this.keywordFromMap === false && value === '') {
        this.searchClear()
      } else {
        if (this.resultListViewShow === true) {
          this.resultListViewShow = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>

    .addplot-contrast-list{
          width: 100%;
          height: 520px;
          background: #ffffff;
          border-radius: 4px;
          right: 10px;
          top: 40px;
        }
        .header{
            height: 44px;
            padding: 10px;
            border-bottom: 1px solid #dedede;
            .go-back{
                height: 24px;
                background: #4293f4;
                border-radius: 4px;
                color: #ffffff;
                cursor: pointer;
                line-height: 24px;
                padding: 0px 8px;
                display: inline-block;
                margin-right: 10px;
                i.iconfont{
                    font-size: 14px;
                }
            }
            .name{
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                vertical-align: middle;
            }
            .operation{
                line-height: 24px;
                i.iconfont{
                    font-size: 14px;
                    margin-left: 10px;
                    cursor: pointer;
                }
            }
        }
        .plot{
            padding: 20px 0px;
            width: 100%;
            position: relative;
            top: 50px;
            .plot-table{
                height: 100%;
                width: 100%;
                .table-header{
                    padding:0px 10px;
                    table{
                        width: 100%;
                        border-collapse:collapse;
                        border-spacing:0;
                        td{
                            border: 1px solid #e5e9eb;
                            background: #f1f4f8;
                            border-bottom: none;
                            font-size: 16px;
                            font-weight: bold;
                            color: #333;
                            padding:14px 10px;
                            &:first-child{
                                font-size: 16px;
                                font-weight: normal;
                                color: #999999;
                            }
                        }
                    }
                }
                .table-body{
                    height: calc(100% - 42px);
                    .body-content{
                        padding: 0px 10px;
                        table{
                          width: 440px;
                          border-collapse: collapse;
                          position: relative;
                          border-spacing: 0;
                          top: 50px;
                          left: 10px;
                            tr{
                                &:nth-child(odd){
                                    td{
                                        background: #fff;
                                    }
                                }
                                &:nth-child(even){
                                    td{
                                        background: #f1f4f8;
                                    }
                                }
                            }
                            td{
                                border: 1px solid #e5e9eb;
                                background: #f1f4f8;
                                font-size: 16px;
                                font-weight: normal;
                                color: #333;
                                padding:14px 10px;
                                &:first-child{
                                    font-size: 16px;
                                    font-weight: normal;
                                    color: #999999;
                                }
                                .table-img{
                                    height: 197px;
                                    width: 100%;
                                    img{
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                    ::v-deep{
                        .el-scrollbar__wrap{
                            overflow-x: hidden;
                        }
                    }
                }
            }
        }
    .globalSearchbar {
        position: absolute;
        left: 20px;
        top: 60px;
        z-index: 490;
        width: 440px;
        ::v-deep{
            .el-select {
                .el-input {
                    width: 80px;
                }
            }
            .el-input-group__append {
                width: 53px;
                background: #2b74e5;
                border: 1px solid rgba(0, 0, 0, 0);
                opacity: 1;
                border-radius: 0px 4px 4px 0px;
                color: #fff;
            }
            .el-input-group__prepend {
                border-right: 0;
                background: #fff;
                color: #333333;
            }
        }
    }
    .adddk{
     width: 125px;
    height: 40px;
    background: #2789ee;
    border-radius: 4px;
    cursor: pointer;
    font-size: 15px;
    color: #ffffff;
    line-height: 40px;
    border: 0px;
}
</style>
